<script setup>
import { useLiveEventStore } from '~~/store/event'

const store = useLiveEventStore()
const liveEvent = computed(() => store.liveEvent)
const hasNotification = computed(() => !!liveEvent.value)
const { t } = useI18n()

await store.fetchLiveEvent()

const eyebrow = computed(() =>
  liveEvent.isLivestream ? t('contentCard.live') : t('contentCard.watch')
)
</script>

<template>
  <NuxtLink v-if="hasNotification" class="global-notifications" to="/#featured">
    <CardContent
      layout="livestream"
      :eyebrow="eyebrow"
      icon="circle"
      :title="liveEvent.title"
      :slug="liveEvent.slug"
      :thumbnail="liveEvent.thumbnail?.url"
    />
  </NuxtLink>
</template>
